var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCourageousPowerfulIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 70,
    viewBox: "0 0 69 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 68.0045C53.0015 68.0045 68 53.005 68 34.5022C68 15.9995 53.0015 1 34.5 1C15.9984 1 1 15.9995 1 34.5022C1 53.005 15.9984 68.0045 34.5 68.0045Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7158 42.0413C27.2619 42.0413 30.9472 36.9629 30.9472 30.6984C30.9472 24.4339 27.2619 19.3555 22.7158 19.3555C18.1697 19.3555 14.4844 24.4339 14.4844 30.6984C14.4844 36.9629 18.1697 42.0413 22.7158 42.0413Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.02 38.882C26.2931 38.882 28.1357 36.3428 28.1357 33.2105C28.1357 30.0783 26.2931 27.5391 24.02 27.5391C21.747 27.5391 19.9043 30.0783 19.9043 33.2105C19.9043 36.3428 21.747 38.882 24.02 38.882Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.549 17.13C51.549 17.13 48.4861 12.2482 42.9825 13.708C42.9825 13.708 38.3763 14.9524 37.9336 20.7794C37.9336 20.7794 42.4322 13.3012 51.549 17.13Z",
    fill: "#231F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2682 14.6997C33.2682 14.6997 30.1216 19.5216 24.6419 17.9542C24.6419 17.9542 20.0596 16.6261 19.7246 10.7871C19.7246 10.7871 24.0796 18.349 33.2682 14.6997Z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0752 42.0413C51.6213 42.0413 55.3066 36.9629 55.3066 30.6984C55.3066 24.4339 51.6213 19.3555 47.0752 19.3555C42.5291 19.3555 38.8438 24.4339 38.8438 30.6984C38.8438 36.9629 42.5291 42.0413 47.0752 42.0413Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.856 38.882C51.129 38.882 52.9717 36.3428 52.9717 33.2105C52.9717 30.0783 51.129 27.5391 48.856 27.5391C46.5829 27.5391 44.7402 30.0783 44.7402 33.2105C44.7402 36.3428 46.5829 38.882 48.856 38.882Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0195 51.1094C24.0195 51.1094 34.6917 55.2254 44.981 51.1094H24.0195Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0195 51.1094C24.0195 51.1094 34.6917 55.2254 44.981 51.1094",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourageousPowerfulIcon);
export default __webpack_public_path__ + "static/media/courageous-powerful-icon.e5d0b0ee1202a88c4235c52f5c3c5f92.svg";
export { ForwardRef as ReactComponent };